import React from "react";

const CPP_While_Loop = () => {
  return (
    <div>
      <h1>CPP_While_Loop Component</h1>
      <p>Content for CPP_While_Loop goes here...</p>
    </div>
  );
};

export default CPP_While_Loop;
